module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_null@3x.c0103324.png";